const CallToActionSecurity = () => {
  return (
    <svg viewBox="0 0 1280 369" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="-1280"
        y="-369"
        width="3840"
        height="1107"
        fill="url(#grid-pattern-cta-security)"
        transform="translate(2, 10)"
      />
      <line x1="400" y1="428.107" x2="400" y2="307.107" stroke="#915EFF" />
      <line
        y1="-0.5"
        x2="121"
        y2="-0.5"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 440.5 428.107)"
        stroke="#915EFF"
      />
      <line
        y1="-0.5"
        x2="160"
        y2="-0.5"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 480.5 428.107)"
        stroke="#915EFF"
      />
      <line
        y1="-0.5"
        x2="160"
        y2="-0.5"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 560.5 428.107)"
        stroke="#915EFF"
      />
      <line
        y1="-0.5"
        x2="160"
        y2="-0.5"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 600.5 428.107)"
        stroke="#915EFF"
      />
      <line
        y1="-0.5"
        x2="160"
        y2="-0.5"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 640.5 428.107)"
        stroke="#915EFF"
      />
      <path d="M680.5 428.107L681 228.107" stroke="#915EFF" />
      <line
        y1="-0.5"
        x2="160"
        y2="-0.5"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 721 428.107)"
        stroke="#915EFF"
      />
      <line
        y1="-0.5"
        x2="241"
        y2="-0.5"
        transform="matrix(-8.74228e-08 -1 -1 8.74228e-08 761 428.107)"
        stroke="#915EFF"
      />
      <line
        y1="-0.5"
        x2="160"
        y2="-0.5"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 801 428.107)"
        stroke="#915EFF"
        strokeDasharray="2 2"
      />
      <line
        y1="-0.5"
        x2="201"
        y2="-0.5"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 841 428.107)"
        stroke="#915EFF"
      />
      <line
        y1="-0.5"
        x2="160"
        y2="-0.5"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 881 428.107)"
        stroke="#915EFF"
        strokeDasharray="2 2"
      />
      <line
        y1="-0.5"
        x2="241"
        y2="-0.5"
        transform="matrix(-8.74228e-08 -1 -1 8.74228e-08 921 428.107)"
        stroke="#915EFF"
      />
      <line
        y1="-0.5"
        x2="279"
        y2="-0.5"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 961 428.107)"
        stroke="#915EFF"
      />
      <line
        y1="-0.5"
        x2="280"
        y2="-0.5"
        transform="matrix(-5.64018e-08 -1 -1 3.38763e-08 1001 428.107)"
        stroke="#915EFF"
        strokeDasharray="2 2"
      />
      <line
        y1="-0.5"
        x2="311"
        y2="-0.5"
        transform="matrix(-5.64018e-08 -1 -1 3.38763e-08 1041 428.107)"
        stroke="#915EFF"
      />
      <line
        x1="1080.5"
        y1="428.107"
        x2="1080.5"
        y2="148.107"
        stroke="#915EFF"
        strokeDasharray="2 2"
      />
      <path d="M1121 428.107L1121 69.1068" stroke="#915EFF" />
      <line
        x1="1160.5"
        y1="428.107"
        x2="1160.5"
        y2="117.107"
        stroke="#915EFF"
        strokeDasharray="2 2"
      />
      <line
        x1="1200.5"
        y1="428.107"
        x2="1200.5"
        y2="57.1068"
        stroke="#915EFF"
      />
      <line
        x1="1240.5"
        y1="428.107"
        x2="1240.5"
        y2="25.1068"
        stroke="#915EFF"
      />

      <defs>
        <pattern
          id="grid-pattern-cta-security"
          viewBox="0 0 40 40"
          width="1.04166667%"
          height="3.61336947%"
        >
          <rect
            width="40"
            height="40"
            fill="var(--color-background-inverted)"
          />
          <line
            x1="39"
            y1="0"
            x2="39"
            y2="39"
            stroke="var(--brand-color-grey-9)"
            strokeDasharray="2 2"
            strokeOpacity="0.5"
          />
          <line
            x1="0"
            y1="39"
            x2="39"
            y2="39"
            stroke="var(--brand-color-grey-9)"
            strokeDasharray="2 2"
            strokeOpacity="0.5"
          />
        </pattern>
      </defs>
    </svg>
  );
};

export default CallToActionSecurity;
